"use strict";
// DO NOT EDIT THIS FILE, EDIT THE GULP TASK SETTINGS INSTEAD WHICH GENERATES THIS FILE

angular.module("courseApp", ["ngRoute","ngResource","ngCookies","http-auth-interceptor","ngTable","ui.select","ngSanitize","moment-picker"])
.constant("ATTENDEE_TYPE", [{"id":"T","title":"Teilnehmer"},{"id":"A","title":"Ausbilder"},{"id":"D","title":"Divers"}])
.constant("CONFIG", {"authURL":"https://spe.deutscherskiverband.de/api/api-token-auth/","backendURL":"https://spe.deutscherskiverband.de/api/","apiURL":"https://spe.deutscherskiverband.de/api/api/course/","imagePath":"./images"});
